<template>
    <div>
        <UserCRUDModal
            ref="userCRUDModal"
            :from="from"
            @refresh="fetchUsers"
        />

        <b-table
            :data="records"
            :striped="true"
            :loading="loading"
            :mobile-cards="true"
            :total="100"
            :sort-icon="'chevron-up'"
        >
            <template>
                <b-table-column v-slot="props" field="name" label="Naam">
                    {{ props.row.name }}
                </b-table-column>

                <b-table-column v-slot="props" field="email" label="E-mailadres">
                    <span style="user-select: text;width: 200px;display: inline-block;white-space: nowrap;overflow: hidden !important;text-overflow: ellipsis;">
                        {{ props.row.email }}
                    </span>
                </b-table-column>

                <b-table-column v-slot="props" field="organisations" label="Organisatie(s)" :visible="from === 'AccountsOverview'" sortable>
                    <span v-if="props.row.organisations.length === 0">
                        -
                    </span>
                    <span v-else-if="props.row.organisations.length === 1">
                        {{ props.row.organisations[0].organisation.name }}
                    </span>
                    <span v-else>
                        <b-tooltip :label="getOrganisationsTooltip(props.row.organisations)">
                            <b-button type="is-light" size="is-small">{{ props.row.organisations.length }} organisaties</b-button>
                        </b-tooltip>
                    </span>
                </b-table-column>

                <b-table-column v-slot="props" field="user_organisation" label="Rol">
                    {{ props.row.role === 'pit' ? 'PlanitEasy' : parseUserRole(props.row, props.row.user_organisation?.role) }}
                </b-table-column>

                <b-table-column v-slot="props" field="temp_pass" label="Geactiveerd">
                    <b-tag type="is-danger" v-if="props.row.temp_pass">Nee</b-tag>
                    <b-tag type="is-success" v-else>Ja</b-tag>
                </b-table-column>

                <b-table-column v-slot="props" field="invited_at" label="Uitgenodigd op">
                    <!-- <span v-if="notInvitedOrganisation(props.row)">Niet uitgenodigd</span>
                    <span v-else-if="props.row.user_organisation?.created_at">{{ (props.row.user_organisation?.created_at || props.row.created_at)|humanDateTime }}</span>
                    <span v-else>-</span> -->
                    <span v-if="props.row.invited_at">{{ props.row.invited_at|humanDateTime }}</span>
                    <span v-else>Niet uitgenodigd</span>
                </b-table-column>

                <b-table-column v-slot="props" field="actions" width="100" :visible="user.is_admin" numeric>
                    <div class="invoice-options-dropdown">
                        <b-button type="is-dark" size="is-small" @click="() => $refs.userCRUDModal.toggleModal('edit', props.row.organisation, props.row)">Aanpassen</b-button>
                        <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left" class="is-inline-block">
                            <template #trigger>
                                <b-button
                                    type="is-dark"
                                    size="is-small"
                                    icon-right="chevron-down" />
                            </template>
                            <b-dropdown-item @click="() => $refs.userCRUDModal.promptDelete(props.row.id, props.row.user_organisation.organisation)" :disabled="props.row.user_organisation.role === 'owner'">
                                Verwijderen
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </b-table-column>
            </template>

            <template #empty>
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p class="margin0" v-if="loading === false">Geen gebruikers gevonden.</p>
                        <p class="margin0" v-else>Laden...</p>
                    </div>
                </section>
            </template>
        </b-table>
    </div>
</template>

<script>
import Vue from 'vue'
import UserCRUDModal from './UserCRUDModal.vue'
import filtersMixin from '@/mixins/filterMixins'

const newUser = {
    name: '',
    email: '',
    admin: false
}

export default {
    name: 'UsersOverviewTable',

    mixins: [filtersMixin],

    components: {
        UserCRUDModal
    },

    props: {
        from: {
            type: String,
            required: false
        },
        organisation_id: {
            type: [Number, String],
            required: false
        }
    },

    data() {
        return {
            loading: false,
            records: [],
            errors: [],
            modalActive: false
        }
    },

    computed: {
        user(){
            return this.$store.state.user
        }
    },

    created () {
        this.loading = true
    },

    methods: {
        fetchUsers(params = null){
            this.loading = true
            this.$emit('passLoading', true)

            if(this.organisation_id) {
                params = `organisation=${this.organisation_id}`
            }

            axios.get(`/api/users${params ? '?'+params : ''}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                Vue.set(this, 'records', response.data.data)
                this.$emit('passTotal', response.data.total)
            }).catch((error) => {
                console.error('[❌] Error while fetching users!', error)
            }).then(() => {
                this.loading = false
                this.$emit('passLoading', false)
            })
        },

        addUser(mode, preferedOrganisation) {
            this.$refs.userCRUDModal.toggleModal(mode, preferedOrganisation)
        },

        loadAsyncData(){
            this.fetchUsers()
        },

        parseUserRole(user, role){
            if (user.organisations.length > 1) {
                if (this.organisation_id !== 'all') {
                    const org = user.organisations.find(org => org.organisation.id === this.organisation_id)
                    role = org ? org.role : 'multiple'
                } else {
                    const uniqueRoles = new Set(user.organisations.map(org => org.role))

                    if (uniqueRoles.size === 1 && uniqueRoles.has(role)) {
                        role = role
                    } else {
                        if (this.user.role === 'pit') {
                            role = 'multiple'
                        }
                    }
                }
            }

            return this.switchRole(role)
        },

        switchRole (role) {
            switch(role){
                case 'pit':
                    return 'PlanitEasy'
                case 'multiple':
                    return 'Verschillende'
                case 'owner':
                    return 'Eigenaar'
                case 'admin':
                    return 'Administrator'
                case 'deurwaarder':
                    return 'Deurwaarder'
                default:
                    return 'Gebruiker'
            }
        },

        getOrganisationsTooltip(organisations) {
            if (this.user.role === 'pit') {
                return organisations.map(org => org.organisation.name).join(', ');
            }

            const known = [];
            const unknown = [];

            organisations.forEach(org => {
                const exists = this.$store.state.user.organisations[org.organisation.id];
                if (exists) {
                    known.push(org.organisation.name);
                } else {
                    unknown.push(org.organisation.name);
                }
            });

            if (unknown.length === 0) {
                return known.join(', ');
            }

            if (known.length === 0) {
                return `${unknown.length} onbekende organisatie${unknown.length > 1 ? 's' : ''}`;
            }

            return `${known.join(', ')} en ${unknown.length} onbekende organisatie${unknown.length > 1 ? 's' : ''}`;
        },
    },

    watch: {
        organisation_id() {
            this.loadAsyncData()
        }
    }
}
</script>